export default __webpack_public_path__ + "static/media/driving-licence-front.25b45bc4.jpg";